import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SaleDocumentItemPriceShouldNotBeLessThanZero extends Violation {
    public constructor() {
        super(ViolationSeverity.Info, 'business.document.sale.validation.items.price.cost-should-not-be-less-than-zero-warning');
    }
}
